<script lang="ts" setup>
import { getOSByUserAgent } from '@/utils/device'

defineOptions({
  name: 'SkeletonGoodsDetailImg'
})

const isDesktop = getOSByUserAgent() === 'desktop'
</script>

<template>
  <div class="skeleton-wrap">
    <div class="skeleton-list">
      <div class="card-item" v-if="isDesktop">
        <div class="card-sum-list">
          <div class="card-img is-skeleton"></div>
          <div class="card-img is-skeleton"></div>
          <div class="card-img is-skeleton"></div>
          <div class="card-img is-skeleton"></div>
          <div class="card-img is-skeleton"></div>
          <div class="card-img is-skeleton"></div>
          <div class="card-img is-skeleton"></div>
        </div>
        <div class="card-main">
          <div class="card-img is-skeleton"></div>
        </div>
      </div>
      <div class="card-item" v-else>
        <div class="card-img is-skeleton"></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use './index.scss';
</style>
